// Purpose: Product API calls — CRUD with FormData for image upload
// Caller: productAction
// Dependencies: utils/xhr, utils/objToFormData
// Main Functions: getProducts, createProduct, updateProduct, deleteProduct
// Side Effects: HTTP GET/POST/PUT/DELETE /product

import { xhr, objToFormData } from 'utils'

export const getProducts = (params = '') => xhr.get(`/product?${params}`)
export const getProductDashboard = (params = '') => xhr.get(`/product-dashboard?${params}`)
export const getProductDashboardBestSeller = (params = '') =>
  xhr.get(`/product-dashboard/best-sellers?${params}`)
export const getProductRecap = (params = '') => xhr.get(`/product-recap?${params}`)

export const createProduct = (data) => {
  const formData = objToFormData({
    ...data,
    size: JSON.stringify(data.size),
    color: JSON.stringify(data.color),
    variation: JSON.stringify(data.variation),
  })
  return xhr.post('/product', formData)
}

export const updateProduct = (data, id) => {
  const formData = objToFormData({
    ...data,
    size: JSON.stringify(data.size),
    color: JSON.stringify(data.color),
    variation: JSON.stringify(data.variation),
  })
  return xhr.put(`/product/${id}`, formData)
}

export const deleteProduct = (id) => xhr.delete(`/product/${id}`)
